/* eslint-disable react/prop-types */

import React from 'react';

function SDColourCircleWithText({ color = "#FF5733", size = 20, text = "Hello" }) {
  const circleStyle = {
    display: "inline-block",
    width: `${size}px`,
    height: `${size}px`,
    backgroundColor: color,
    borderRadius: "50%",
    verticalAlign: "middle", 
    marginRight: "8px", 
  };

  return (
    <span>
      <span style={circleStyle}></span>
      <span style={{ verticalAlign: "middle" }}>{text}</span>
    </span>
  );
}

export default SDColourCircleWithText;